<template>
    <div id="paymentInProgressPage">
        <div class="container bg-white p-4 mb-2">
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column mr-5">
                    <span class="font-md font-weight-bold text-gray-dk mb-2">Your payment is in progress</span>
                    <span class="font-xs text-secondary">Please review and authorize your payment in the Home Credit app.</span>
                </div>
                <img alt="" src="/img/hcpay/payment-in-progress.svg" class="paymentInProgressIcon img-responsive">
            </div>
            <warning-bar class="mt-4 mb-2">This page will automatically update once your payment is complete.</warning-bar>
        </div>
        <div class="container d-flex flex-column justify-content-center bg-white px-0 py-4">
            <merchant-details/>
            <hr class="customDivider my-4">
            <div class="px-4">
                <payment-summary class="mx-auto"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        changeView(view) {
            this.$root.$data.view = view;
        }
    },
    created(){
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('payment_in_progress_page',g4params);
        this.$root.$data.previousView = 'payment-in-progress';
    }
}
</script>
<style scoped>
    .paymentInProgressIcon {
        height: auto;
        width: 8rem;
    }
</style>